module.exports = __webpack_public_path__ + "img/icon-app.b08f2d49.svg";